import { useQuery } from '@tanstack/react-query';
import type { ListParams } from '@/interceptors/axiosInstance.ts';
import {
  fetchAuditLogById,
  fetchAuditLogs,
  fetchAuditLogsByEntity,
} from '@/features/auditLog/audit-log-api.ts';

export const auditLogKeys = {
  all: ['audit-logs'] as const,
  lists: () => [...auditLogKeys.all, 'list'] as const,
  list: (params: Partial<ListParams>) => [...auditLogKeys.lists(), params] as const,
  details: () => [...auditLogKeys.all, 'detail'] as const,
  detail: (id: number) => [...auditLogKeys.details(), id] as const,
  byEntity: (entityId: string) => [...auditLogKeys.all, 'by-entity', entityId] as const,
};

export function useAuditLogs(params: Partial<ListParams> = {}) {
  return useQuery({
    queryKey: auditLogKeys.list(params),
    queryFn: () => fetchAuditLogs(params),
  });
}

export function useAuditLog(id: number) {
  return useQuery({
    queryKey: auditLogKeys.detail(id),
    queryFn: () => fetchAuditLogById(id),
    enabled: !!id,
  });
}

export function useAuditLogsByEntity(entityId: string) {
  return useQuery({
    queryKey: auditLogKeys.byEntity(entityId),
    queryFn: () => fetchAuditLogsByEntity(entityId),
    enabled: !!entityId,
  });
}
